<template>
  <Typography.Paragraph
    v-show="getBindValue.content"
    :class="'!mb-0 ' + (reverse ? 'ant-typography-reverse' : '')"
    v-bind="getBindValue"
  />
</template>

<script setup lang="ts">
  import { Typography } from 'ant-design-vue';
  import { computed, useAttrs } from 'vue';
  import type { CellProps } from '@mts/components/Table';
  import type { ParagraphProps } from 'ant-design-vue/es/typography/Paragraph';
  import { warn } from '@mts/utils';

  defineOptions({
    name: 'BaseParagraph',
    inheritAttrs: false,
  });

  interface BaseParagraphProps extends Partial<CellProps>, ParagraphProps {
    reverse?: boolean;
    value?: unknown;
  }
  const props = defineProps<BaseParagraphProps>();
  const attrs = useAttrs();
  const getBindValue = computed(() => {
    const {
      value,
      text,
      record,
      column,
      index,
      reverse,
      ellipsis: _ellipsis,
      ...restProps
    } = props;

    let content = restProps.content || value || text;
    let ellipsis: ParagraphProps['ellipsis'] = _ellipsis;
    if (_ellipsis !== false) {
      !props.copyable && warn('当前组件已废弃，请使用 TooltipText（提示+溢出省略）');
      ellipsis = { tooltip: true, rows: 3, ...(_ellipsis === true ? {} : _ellipsis) };
    }

    return { ...attrs, ...restProps, content, ellipsis } as ParagraphProps;
  });
</script>

<style lang="less">
  .ant-typography-reverse {
    display: inline-flex;
    flex-direction: row-reverse;

    > div {
      margin-right: 4px;
      margin-left: 0 !important;
    }
  }
</style>
